export class CreateCheckout {
  constructor(baseUrl) {
    if (!baseUrl) {
      throw new Error('Missing base URL in CreateCheckout');
    }
    this.baseUrl = baseUrl;
    this.params = {};
    this.moduleIds = [];
  }

  withRedirect() {
    this.params.redirect = true;
    return this;
  }

  withoutRedirect() {
    this.params.redirect = false;
    return this;
  }

  withOrgId(orgId) {
    if (!orgId) {
      throw new Error('Missing organization ID');
    }
    this.params.orgId = orgId;
    return this;
  }

  withModuleId(moduleId) {
    if (!moduleId) {
      throw new Error('Missing module ID');
    }
    this.moduleIds.push(moduleId);
    return this;
  }

  withModuleIds(moduleIds) {
    if (!Array.isArray(moduleIds) || moduleIds.length === 0) {
      throw new Error('Module IDs must be a non-empty array');
    }
    this.moduleIds = [...this.moduleIds, ...moduleIds];
    return this;
  }

  withSuccessURL(successUrl) {
    if (!successUrl) {
      throw new Error('Missing success URL');
    }
    this.params.successUrl = successUrl;
    return this;
  }

  withReturnURL(returnUrl) {
    if (!returnUrl) {
      throw new Error('Missing return URL');
    }
    this.params.returnUrl = returnUrl;
    return this;
  }

  withCancelURL(cancelUrl) {
    if (!cancelUrl) {
      throw new Error('Missing cancel URL');
    }
    this.params.cancelUrl = cancelUrl;
    return this;
  }

  withPaymentMethodTypes(paymentMethodTypes) {
    if (!Array.isArray(paymentMethodTypes) || paymentMethodTypes.length === 0) {
      throw new Error('Payment method types must be a non-empty array');
    }

    const allowedTypes = ['card', 'sepa_debit'];
    const invalidTypes = paymentMethodTypes.filter(
      (type) => !allowedTypes.includes(type)
    );

    if (invalidTypes.length > 0) {
      throw new Error(
        `Invalid payment method types: ${invalidTypes.join(
          ', '
        )}. Allowed types are: ${allowedTypes.join(', ')}`
      );
    }

    this.params.payment_method_types = paymentMethodTypes.join(',');
    return this;
  }

  withUIMode(uiMode) {
    if (!uiMode) {
      throw new Error('Missing UI mode');
    }

    const allowedModes = ['embedded', 'hosted'];
    if (!allowedModes.includes(uiMode)) {
      throw new Error(
        `Invalid UI mode: ${uiMode}. Allowed modes are: ${allowedModes.join(
          ', '
        )}`
      );
    }

    this.params.uiMode = uiMode;
    return this;
  }

  withQuoteId(quoteId) {
    if (!quoteId) {
      throw new Error('Missing quote ID');
    }
    this.params.quoteId = quoteId;
    return this;
  }

  withRedirectOnCompletion(value) {
    const allowedValues = ['always', 'if_required', 'never'];
    if (!allowedValues.includes(value)) {
      throw new Error(
        `Invalid redirectOnCompletion value: ${value}. Allowed values are: ${allowedValues.join(
          ', '
        )}`
      );
    }
    this.params.redirectOnCompletion = value;
    return this;
  }

  getUrl() {
    const queryParams = new URLSearchParams();

    // Add regular params
    Object.entries(this.params).forEach(([key, value]) => {
      queryParams.append(key, value);
    });

    // Add moduleIds
    this.moduleIds.forEach((moduleId) => {
      queryParams.append('moduleIds', moduleId);
    });

    const queryString = queryParams.toString();
    return queryString
      ? `${this.baseUrl}/stripe/checkout?${queryString}`
      : this.baseUrl;
  }
}

export default CreateCheckout;
